import { render, staticRenderFns } from "./proxyAuditDetail.vue?vue&type=template&id=4cc983a7&scoped=true&"
import script from "./proxyAuditDetail.vue?vue&type=script&lang=js&"
export * from "./proxyAuditDetail.vue?vue&type=script&lang=js&"
import style0 from "./proxyAuditDetail.vue?vue&type=style&index=0&id=4cc983a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc983a7",
  null
  
)

export default component.exports